import { render, staticRenderFns } from "./SelectTherapy.vue?vue&type=template&id=c1e9612e&"
import script from "./SelectTherapy.vue?vue&type=script&lang=js&"
export * from "./SelectTherapy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports